
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00732f","d":"M0 0h12v2H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 2h12v2H0z"}}),_c('path',{attrs:{"d":"M0 4h12v2H0z"}}),_c('path',{attrs:{"fill":"red","d":"M0 0h3v6H0z"}})])
          )
        }
      }
    